import { css } from '@/styled-system/css';

export const avatarContainerStyles = css.raw({
  width: '800',
  height: '800',
  borderRadius: '50%',
  display: 'flex',
  alignSelf: 'flex-end',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 'tighter',
  position: 'relative',
});
